import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fs_token") || localStorage.getItem("fs_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const WHATSAPP_NUMBER = "919999999999"; // placeholder business number
export const waLink = (text = "Hi, I am interested in FinSahayak services.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

// Build a wa.me URL targeted at a specific customer's number
export const toWaNumber = (mobile) => {
  const digits = (mobile || "").replace(/\D/g, "");
  if (digits.length === 10) return "91" + digits;
  if (digits.length === 12 && digits.startsWith("91")) return digits;
  if (digits.length === 11 && digits.startsWith("0")) return "91" + digits.slice(1);
  return digits;
};

export const waToCustomer = (mobile, text) => {
  const num = toWaNumber(mobile);
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
};

// Robust error message extractor — handles FastAPI 422 validation errors (detail is an array of objects)
export const getErr = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => {
      if (typeof x === "string") return x;
      const loc = Array.isArray(x?.loc) ? x.loc.filter((p) => p !== "body").join(".") : "";
      const msg = x?.msg || x?.message || JSON.stringify(x);
      return loc ? `${loc}: ${msg}` : msg;
    });
    return msgs.filter(Boolean).join(" · ") || fallback;
  }
  if (d && typeof d === "object") return d.msg || d.message || JSON.stringify(d);
  return e?.message || fallback;
};

// Robust clipboard copy with permissions-policy fallback (iframes, sandboxed contexts).
// Returns true on success, false on failure (never throws).
export const safeCopy = async (text) => {
  if (text === undefined || text === null) return false;
  const str = String(text);

  // 1) Modern async clipboard API
  try {
    if (navigator?.clipboard?.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(str);
      return true;
    }
  } catch (_) { /* fall through to legacy */ }

  // 2) Legacy execCommand('copy') via hidden textarea
  try {
    const ta = document.createElement("textarea");
    ta.value = str;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.left = "0";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, str.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (_) {
    return false;
  }
};
